import React from "react";
import CustomTitle from "@/component/custom-title";
import SimpleCard from "./simple-card";

const OtherServices = (props) => {
    const listServices = Object.keys(props)
        .filter(key => key.startsWith('Charac-'))
        .map(key => props[key]);
    return (
        <div className="other-services container">
            <div className="other-services_header">
                <CustomTitle title={props && props['Text-1']} background="#EEEEEE" />
            </div>
            <div className="other-services_content">
                {listServices.map((e, index) => {
                    return (
                        <SimpleCard key={`other-services-item-${index}`} {...e} />
                    );
                })}
            </div>
            <style jsx>{`
        .other-services {
            margin-top: 2rem;
            .other-services_content {
                display: grid;
                grid-template-columns: repeat(auto-fill,minmax(190px,1fr));
                gap: 1.5rem;
                margin-bottom: 1rem;
                @media screen and (max-width: 480px) {
                    grid-template-columns: repeat(auto-fill,minmax(158px,1fr));
                    gap: 1rem;
                }
            }
        }
      `}</style>
        </div>
    );
};

export default OtherServices;
